import React, {useState} from "react";
import {Modal} from "antd";
import StandardTable, {StandardColumnsType} from "../StandardTable";
import dayjs from "dayjs";
import useAntTable from "../../utils/useAntTable";

interface Props {
    type: string,
    objectId: any
    onClose: () => void
}

function LogModalElement(props: Props) {

    const {type, objectId, onClose} = props

    const {tableProps, refresh} = useAntTable(`/log/?type=${type}&objectId=${objectId}`, {})

    const [open, setOpen] = useState(true)

    const columns: StandardColumnsType = [
        {
            title: '操作说明',
            dataIndex: 'title',
        },
        {
            title: '操作人',
            dataIndex: 'createName',
        },
        {
            title: '备注',
            dataIndex: 'description',
            render: (data) => <div style={{whiteSpace: 'pre-line'}}>{data}</div>
        },
        {
            title: '操作时间',
            dataIndex: 'createTime',
            render: (value) => dayjs(value).format('lll')
        }
    ]

    return (
        <Modal title={'日志'} open={open} onCancel={() => setOpen(false)} afterClose={onClose} width={1200}
               footer={null}>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} showCard={false} pagination={false}/>
        </Modal>
    )
}

export default LogModalElement
